import { CheckListItem } from '$tablet-app/src/app/models';
import { findAndUpdateRecord } from '$tablet-app/src/app/utils/arrays';
import { ChecklistModel } from '@akin-home/checklists';
import {
  useGetTaskList,
  useUpdateTaskListItem,
} from '@akin-home/checklists/frontend';
import React, { FC } from 'react';
import { TaskListItemView } from '../TaskListItemView/TaskListItemView';

const TaskListItemChatView: FC<{ id: string }> = (props) => {
  const { id } = props;

  const { list: data } = useGetTaskList({ id });
  const setChecklistItem = useUpdateTaskListItem();

  const onChecklistPress = async (
    item: ChecklistModel,
    checklistItem: CheckListItem
  ) => {
    setChecklistItem({
      id: item.id,
      checklist: findAndUpdateRecord(item.checklist, checklistItem),
    });
  };

  return data ? (
    <TaskListItemView item={data} onChecklistPress={onChecklistPress} />
  ) : null;
};

export default TaskListItemChatView;
